import React from "react"

import AppBar from '@mui/material/AppBar'
import Box from '@mui/material/Box'
import Toolbar from '@mui/material/Toolbar'
import Typography from '@mui/material/Typography'
import Container from '@mui/material/Container'
import Menu from '@mui/material/Menu'
import {Button, MenuItem} from "@mui/material";
import { Link as RouterLink } from 'react-router'
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown"

const Nav = () => {
    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    const handleClick = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };
    const open = Boolean(anchorEl)
    return (
        <AppBar position="static" elevation={1} sx={{mb: 0.5}}>
            <Container maxWidth="xl">
                <Toolbar disableGutters>
                    <Typography
                        variant="h6"
                        noWrap
                        component="a"
                        href="/ff"
                        sx={{
                            mr: 2,
                            display: {xs: 'none', md: 'flex'},
                            fontFamily: 'monospace',
                            fontWeight: 700,
                            letterSpacing: '.3rem',
                            color: 'inherit',
                            textDecoration: 'none',
                        }}
                    >
                        <img
                            height="100"
                            width="100"
                            src={`${process.env.PUBLIC_URL}/xOoIx.png`}
                            alt="F.U.C.K"
                            title="F.U.C.K"
                        />
                    </Typography>
                    <Box sx={{flexGrow: 1, display: {xs: 'flex', md: 'none'}}}>
                        <Typography
                            variant="h5"
                            noWrap
                            component="a"
                            href="/ff"
                            sx={{
                                mr: 2,
                                display: {xs: 'flex', md: 'none'},
                                flexGrow: 1,
                                fontFamily: 'monospace',
                                fontWeight: 700,
                                letterSpacing: '.3rem',
                                color: 'inherit',
                                textDecoration: 'none',
                            }}
                        >
                            <img
                                height="100"
                                width="100"
                                src={"/ff/xOoIx.png"}
                                alt="F.U.C.K"
                                title="F.U.C.K"
                            />
                        </Typography>
                    </Box>
                    <Box sx={{flexGrow: 1, display: {xs: 'none', md: 'flex'}, justifyContent: 'center'}}>
                    </Box>
                    <Box sx={{flexGrow: 0}}>
                        <Button
                            id="basic-button"
                            aria-controls={open ? 'basic-menu' : undefined}
                            aria-haspopup="true"
                            aria-expanded={open ? 'true' : undefined}
                            variant="contained"
                            disableElevation
                            onClick={handleClick}
                            endIcon={<KeyboardArrowDownIcon />}
                        >
                            History
                        </Button>
                        <Menu
                            id="basic-menu"
                            anchorEl={anchorEl}
                            open={open}
                            onClose={handleClose}
                            slotProps={{
                                list: {
                                    'aria-labelledby': 'basic-button',
                                },
                            }}
                        >
                            <MenuItem
                                onClick={handleClose}
                                to="/ff/2024"
                                component={RouterLink}
                            >2024
                            </MenuItem>
                            <MenuItem
                                onClick={handleClose}
                                to="/ff/2025"
                                component={RouterLink}
                            >2025
                            </MenuItem>
                        </Menu>
                    </Box>
                </Toolbar>
            </Container>
        </AppBar>
    )
}

export default Nav
